import React, { useEffect, useState } from "react";

// ASSETS
import Illustration from "assets/icons/Deco corner homepage _ About Board DSU_.svg";
import SecondIllustration from "assets/icons/margin homepage _ About Board DSU_.svg";
import HomePgImage4vrt from "assets/img/homepage/HomePgImage4vrt.jpg";
import HomePgImage7vrt from "assets/img/homepage/HomePgImage7vrt.jpg";
import HomePgImage8vrt from "assets/img/homepage/HomePgImage8vrt.jpg";
import HomePgImage13vrt from "assets/img/homepage/HomePgImage13vrt.jpeg";
import HomePgImage14vrt from "assets/img/homepage/HomePgImage14vrt.jpeg";
import HomePgImage1orz from "assets/img/homepage/HomePgImage1orz.jpg";
import HomePgImage5orz from "assets/img/homepage/HomePgImage5orz.jpg";
import HomePgImage6orz from "assets/img/homepage/HomePgImage6orz.jpg";
import HomePgImage9orz from "assets/img/homepage/HomePgImage9orz.jpg";
import HomePgImage10orz from "assets/img/homepage/HomePgImage10orz.jpg";

// STYLES
import {
  ParentContainer,
  Section,
  SectionIllustration,
  SectionSecondIllustration,
  Title,
} from "./CardsSectionStyled";

// LIBRARIES
import { useTranslation } from "react-i18next";

// MISC
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";
import { IProps } from "./CardsSectionModel";

// REDUX

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";
import HomePageCustomCard from "components/HomePageCustomCard/HomePageCustomCard";
import homeService from "services/homeService";
import { CardType } from "components/HomePageCustomCard/HomePageCustomCardModel";
import useWindowWidth from "hooks/useWindowWidth";
import { uploadBaseUrl } from "services/base";

const CardsSection: React.FC<IProps> = () => {
  // PROPERTIES

  // LIBRARY CONSTANTS
  const windowWidth = useWindowWidth();
  const { t } = useTranslation();

  // STATE CONSTANTS
  const [intro, setIntro] = useState<any>();
  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS
  useEffect(() => {
    // setLoading(true);
    homeService
      .getIntroduction()
      .then((response) => {
        // console.log("getIntroduction resp", response);
        setIntro(response.data);
        // setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        // setLoading(false);
      });
  }, []);

  const cards =
    windowWidth > 1227
      ? [
          {
            type: CardType.Content,
            content: {
              title:
                intro?.attributes?.title ||
                t("view.homePage.cardSection.subtitle"),
              paragraph: intro?.attributes?.content,
            },
            colSpan: 2,
            rowSpan: 2,
          },
          {
            type: CardType.Image,
            content: intro?.attributes?.photos?.data[0]?.attributes?.url?.trim()
              ? uploadBaseUrl + "/uploads/amb_c7c89aa6d5.jpeg"
              : HomePgImage14vrt,
            colSpan: 1,
            rowSpan: 1,
          },
          {
            type: CardType.Image,
            content: intro?.attributes?.photos?.data[1]?.attributes?.url?.trim()
              ? uploadBaseUrl + intro.attributes.photos.data[1].attributes.url
              : HomePgImage7vrt,
            colSpan: 1,
            rowSpan: 1,
          },
          {
            type: CardType.Image,
            content: intro?.attributes?.photos?.data[2]?.attributes?.url?.trim()
              ? uploadBaseUrl + "/uploads/upu_1c868e90f5.jpeg"
              : HomePgImage8vrt,
            colSpan: 1,
            rowSpan: 1,
          },
          {
            type: CardType.Image,
            content: intro?.attributes?.photos?.data[3]?.attributes?.url?.trim()
              ? uploadBaseUrl + intro.attributes.photos.data[3].attributes.url
              : HomePgImage13vrt,
            colSpan: 1,
            rowSpan: 2,
          },
          {
            type: CardType.Title,
            content:
              intro?.attributes?.moto || t("view.homePage.cardSection.motto"),
            colSpan: 2,
            rowSpan: 1,
          },
          {
            type: CardType.Image,
            content: intro?.attributes?.photos?.data[4]?.attributes?.url?.trim()
              ? uploadBaseUrl + intro.attributes.photos.data[4].attributes.url
              : HomePgImage4vrt,
            colSpan: 1,
            rowSpan: 1,
          },
        ]
      : [
          {
            type: CardType.Content,
            content: {
              title: intro?.attributes?.title,
              paragraph: intro?.attributes?.content,
            },
            colSpan: 2,
            rowSpan: 1,
          },
          {
            type: CardType.Image,
            // content: intro?.attributes?.photos?.data[0]?.attributes?.url?.trim()
            //   ? uploadBaseUrl + intro.attributes.photos.data[0].attributes.url
            //   : HomePgImage5orz,
            content: HomePgImage5orz,
            colSpan: 1,
            rowSpan: 1,
          },
          {
            type: CardType.Image,
            // content: intro?.attributes?.photos?.data[1]?.attributes?.url?.trim()
            //   ? uploadBaseUrl + intro.attributes.photos.data[1].attributes.url
            //   : HomePgImage1orz,
            content: HomePgImage7vrt,
            colSpan: 1,
            rowSpan: 1,
          },
          {
            type: CardType.Title,
            content:
              intro?.attributes?.moto || t("view.homePage.cardSection.motto"),
            colSpan: 2,
            rowSpan: 1,
          },
          {
            type: CardType.Image,
            // content: intro?.attributes?.photos?.data[2]?.attributes?.url?.trim()
            //   ? uploadBaseUrl + intro.attributes.photos.data[2].attributes.url
            //   : HomePgImage6orz,
            content: intro?.attributes?.photos?.data[2]?.attributes?.url?.trim()
              ? uploadBaseUrl + "/uploads/upu_1c868e90f5.jpeg"
              : HomePgImage8vrt,
            colSpan: 1,
            rowSpan: 1,
          },
          {
            type: CardType.Image,
            content: intro?.attributes?.photos?.data[3]?.attributes?.url?.trim()
              ? uploadBaseUrl + intro.attributes.photos.data[3].attributes.url
              : HomePgImage13vrt,
            colSpan: 1,
            rowSpan: 2,
          },
          {
            type: CardType.Image,
            content: intro?.attributes?.photos?.data[4]?.attributes?.url?.trim()
              ? uploadBaseUrl + intro.attributes.photos.data[4].attributes.url
              : HomePgImage4vrt,
            colSpan: 1,
            rowSpan: 1,
          },
        ];
  return (
    <ParentContainer>
      <SectionIllustration src={Illustration} alt="" />
      <SectionSecondIllustration src={SecondIllustration} alt="" />
      <Title>
        <CustomText
          text={t("view.homePage.cardSection.title")}
          type={TextType.H2}
          color={COLORS.Yellow}
        />
      </Title>
      <Section>
        {cards.map((card, index) => (
          <HomePageCustomCard
            key={index}
            type={card.type}
            content={card.content}
            colSpan={card.colSpan}
            rowSpan={card.rowSpan}
          />
        ))}
      </Section>
    </ParentContainer>
  );
};

export default CardsSection;
